export type FiltersObject = {
  [key: string]: string | string[] | number | number[] | undefined;
};

export type OptionGroup = {
  id: string;
  label: string;
  options: string[];
};

type FilterSettingsBaseProps = {
  filterKey: string;
  name: string;
  options: string[] | OptionGroup[];
  optionsAreLoading?: boolean;
  getOptionLabel?: (option: string) => string;
};

export type FilterComponentProps<T> = FilterSettingsBaseProps & {
  currentValue: T;
  confirmFilter: (value: T) => void;
  onBackClick?: () => void;
  onClose: () => void;
};

export type FilterSettings<
  O extends FiltersObject,
  // Generic T is only used internally within FilterSettings to maintain type consistency.
  // From the outside, it can be any type — the API does not impose restrictions on it.
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  T = any,
> = FilterSettingsBaseProps & {
  valueGetter: (value: O) => T;
  setFilter: (value: T) => void;
  getChipLabel: (value: Exclude<T, undefined>) => string;
  Component: (props: FilterComponentProps<T>) => JSX.Element;
  validateFilter?: (value: Exclude<T, undefined>) => boolean;
};

export const areOptionsGrouped = (
  options: string[] | OptionGroup[]
): options is OptionGroup[] =>
  options.some(o => typeof o === 'object' && 'id' in o);
